<template lang="pug">
div
  #annotationmMap.comAll(v-dragDiv v-show='addShow&&!actionData.isMini')
    .title.moveDragDiv
      span {{actionData.cnName}}
      i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
      i.el-icon-close(@click='closeAdd')
    .nav
      notationAdd(ref='notationAdd' :type='actionData.payload' @closeAdd='closeAdd' @setCurText='setCurText' @startScreenShot='startScreenShot')
  .showType(:class="{isModel:type==='modelDwg'}")
    .label 绘制形式:
    el-radio(v-model="notationType" :label="1" @change="typeChange") 一对一绘制
    el-radio(v-model="notationType" :label="2" @change="typeChange") 多对一绘制
  .next(v-if='nextShow' @click='openAdd')
    span 下一步
    i.el-icon-d-arrow-right()
</template>

<script>
import notationAdd from "@/CommonDP/mongeView/question/notationAdd.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";

export default {
  components: { notationAdd },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      notationType: 1,
      addShow: false,
      nextShow: false,
      isActive: false // 开始云线作业,多对一绘制时使用
    };
  },
  watch: {
    "actionData.isMini": {
      handler: (val) => {
        if (!val) {
          this.AddCloudNot();
        }
      }
    }
  },
  mounted () {
    console.log("type", this.type);
    this.$message.success("请绘制云线");
    this.notationType = 1;
    window.addEventListener('mousedown', this.handleMousedown);// 监听鼠标事件
    window.addEventListener('keydown', this.handkeyCode, true); // 开启监听键盘按下事件
    this.AddCloudNot();
  },
  methods: {
    typeChange() {
      this.addShow = false;
      mongeApiMlib.clearAnnotation();
      this.AddCloudNot();
    },
    // 添加云线
    AddCloudNot() {
      mongeApiMlib.addAnnotation("", {
        callback: (type, data) => {
          if (type === Monge.CallbackType.ANNOTATION_ITEM_DONE) {
            if (this.notationType === 1) {
              this.addShow = true;
              mongeApiMlib.annotationEnd();
            } else {
              this.$warn("点击鼠标右键或键盘空格键/回车键进入下一步");
              this.isActive = true;
            }
          } else if (type === Monge.CallbackType.DONE) {
            const points = data.data.points;
            data.data.point2DTo3D = [];
            for (let i = 0; i < points.length; i += 2) {
              const arr = points.slice(i, i + 2);
              const result = viewer2d.map.convertPoint2DTo3D(new Monge.Vector2(arr[0], arr[1]));
              data.data.point2DTo3D.push(result);
            }
            this.screenCaptureByBox(data);
          }
        }
      });
    },
    // 鼠标事件
    handleMousedown(e) {
      if (e.button === 2 && this.isActive) {
        this.addShow = true;
        mongeApiMlib.annotationEnd();
      }
    },
    // 键盘事件
    handkeyCode(e) {
      if ((e.keyCode === 13 || e.keyCode === 32) && this.isActive) { // 触发了 回车/空格键
        this.addShow = true;
        mongeApiMlib.annotationEnd();
      }
    },
    // 截全屏
    async screenCaptureByBox(data) {
      if (data.bbox) {
        const dataUrl = await mongeApiMlib.mongeScreenCapture(false, this.actionData?.payload);
        this.$refs.notationAdd.screenCaptureByBox(dataUrl, JSON.stringify(data.data) || '');
      }
    },
    // 图纸截图
    async startScreenShot (call) {
      const cutpic = await mongeCommon.startScreenShot(this.actionData?.payload);
      call.callback(cutpic);
    },
    openAdd() {
      this.nextShow = false;
      this.addShow = true;
      mongeApiMlib.annotationEnd();
    },
    setCurText(val) {
      this.addShow = false;
      mongeApiMlib.setMapText(val);
    },
    miniCom() {
      this.$emit("closeCom", 'issue', true);
    },
    async closeAdd(logo) {
      if (logo) await this.$emit('openOther', logo);
      await this.$emit('closeCom', 'issue', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#annotationmMap{
  position: absolute;
  top: 35px;
  right: 30px;
  width: 370px;
  height: calc(100% - 90px);
  max-height: 870px;
  overflow: hidden;
  .nav{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
.showType{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 7px;
  height: 30px;
  // background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 0 10px 10px 0;
  line-height: 30px;
  bottom: 165px;
  cursor: pointer;
  left: 0px;
  background: rgba(255, 255, 255, 1);
  // border-bottom-right-radius: 10px;
  z-index: 4;
  top: 45px;
  .label{
    color: #606266;
    font-size: 14px;
    margin-right: 5px;
  }
  .el-radio{
    margin-right: 15px;
  }
  /deep/.el-radio__label{
    padding-left: 5px;
  }
}
.isModel{
  left: 56px;
}
.next{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 22px;
  height: 30px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  line-height: 30px;
  bottom: 165px;
  cursor: pointer;
  right: 10px;
  z-index: 4;
  i{
    margin-left: 6px;
    font-size: 16px;
  }
}
</style>
